<template>
  <div class="body mobile">
    <!-- Header -->
    <section class="header notice">
      <div class="flexH width">
        <a class="icon iconButton third" @click.prevent="$router.push('/merchant')">
          <font-awesome-icon
            icon="fa-solid fa-chevron-left"
            size="lg"
          ></font-awesome-icon>
        </a>
      </div>
      <span class="fL nowrap font-bold font-white">權限管理</span>
      <div class="flexH width right"></div>
    </section>

    <!-- Main -->
    <section class="main notice pb">
      <div class="records flexV width padding center">
        <div class="input rounded">
          <a class="icon iconButton"><font-awesome-icon icon="fas fa-search" size="sm"></font-awesome-icon></a>
          <input type="text" class="fS" placeholder="搜尋關鍵字" v-model="keywords" @input="onKeywordChange" />
        </div>

        <div class="dropdown rounded mb-4">
          <select class="fM rounded px-3" v-model="storeId">
            <option value="0">選擇特店</option>
            <template v-if="storeList.length > 0">
              <option v-for="store in storeList" :key="store.storeId" :value="store.storeId">{{ store.name }}</option>
            </template>
          </select>
          <div class="arrow">
            <font-awesome-icon icon="fa-solid fa-caret-down" size="xs"></font-awesome-icon>
          </div>
        </div>

        <template v-if="storeUserList.length > 0">
          <div v-for="(item, index) in storeUserList" :key="item.uuid" class="rounded flexH input">
            <div class="fS w-25 mx-2">{{ item.name }}</div>
            <div v-if="item.roles.length === 0" class="fS w-50 mx-2">主要管理者</div>
            <div v-else class="fS w-50 mx-2">{{ item.roles[0].name }}</div>
            <div v-if="user" class="flex w-10 mx-2">
              <template v-if="user.user.id == item.uuid" />
              <template v-else>
                <a v-if="item.roles.length > 0 && item.roles[0].id && item.roles[0].name" href="#" @click.prevent="onStoreUserDelete" :data-index="index" class="flex-1-1 button2 rounded bg-primary text-center fM ms-auto">
                  <img src="@/assets/icon/delete2.svg" />
                </a>
              </template>
            </div>
          </div>
        </template>

        <div class="mt-5 w-45">
          <a class="button rounded" @click.prevent="onStoreUserAdd">
            <span class="fS">新增人員</span>
          </a>
        </div>
      </div>
    </section>

    <StoreUserAdd
      v-if="storeUserAddShow"
      :link="storeUserAdd.link"
      @action="storeUserAddAction"
      @close="storeUserAddClose"
    ></StoreUserAdd>

    <ConfirmDialog
      v-if="storeUserDeleteShow"
      :initOpen="true"
      :title="storeUserDeleteDialog.title"
      :content="storeUserDeleteDialog.message"
      :buttons="storeUserDeleteDialogButtonConfig"
    />
  </div>
</template>

<script>
import { stores } from "@/services/stores.js";
import StoreUserAdd from "@/components/Dialog/StoreUserAdd.vue";
import ConfirmDialog from "@/components/Dialog/ConfirmDialog.vue";

export default {
  components: {
    StoreUserAdd,
    ConfirmDialog
  },
  data() {
    return {
      storeList: [{
        name: 'AAA',
        storeId: 1
      }],
      storeData: null,
      storeId: "0",
      keywords: '',
      storeUserList: [],
      storeUserListBackup: [],
      storeUserAddShow: false,
      storeUserAdd: {
        link: ''
      },
      storeUserDeleteShow: false,
      storeUserDelete: {
        item: null
      },
      storeUserDeleteDialog: {
        title: '',
        message: ''
      },
    };
  },

  computed: {
    user() {
      return this.$store.state.user;
    },

    storeUserDeleteDialogButtonConfig() {
      return [
        {
          text: "返回",
          outline: true,
          click: this.storeUserDeleteClose,
        },
        {
          text: "確認",
          click: this.storeUserDeleteAction
        },
      ];
    }
  },

  watch: {
    user(value) {
      if (value) {
        this.fetchStoreList();
      }
    },

    '$route.params.id'(value) {
      this.storeId = value;
      this.fetchStoreAccessList();
    },

    storeId(value) {
      if (value != '' && value != this.$route.params.id) this.$router.push('/merchant/permission/' + value);
    }
  },

  created() {
    if (this.$route.params.id) {
      this.storeId = this.$route.params.id;
      this.fetchStoreAccessList();
    }
  },

  mounted() {
    if (this.user)
    {
      this.fetchStoreList();
    }
  },

  methods: {
    async fetchStoreList() {
      try
      {
        const res = await stores.getStoreList(this.user.userId);
        this.storeList = stores.useData(res);
      }
      catch (err)
      {
        console.error(err);
        alert('特店列表API暫時無法使用，請稍後再試');
      }
    },

    async fetchStoreAccessList() {
      try
      {
        const res = stores.useData(await stores.getAccessUsers(this.storeId));
        this.storeUserList = res.data.managers;
        this.storeUserListBackup = res.data.managers;
      }
      catch (err)
      {
        console.error(err);
        alert('無法取得商店管理者權限列表資料');
      }
    },

    onStoreUserAdd() {
      this.storeUserAddShow = true;
    },

    storeUserAddClose() {
      this.storeUserAddShow = false;
    },

    async storeUserAddAction(role) {
      if (role)
      {
        try
        {
          const res = stores.useData(await stores.addAccessUrl(this.storeId, {
            permissionRoles: [String(role)]
          }));

          this.storeUserAdd.link = res.data.invitationUrl;
        }
        catch (err)
        {
          console.log(err);
          alert('無法取得權限共享網址');
        }
      }
    },

    onStoreUserDelete(e) {
      let user = this.storeUserList[e.currentTarget.dataset.index];

      this.storeUserDelete = {
        memberUuid: user.uuid
      };

      this.storeUserDeleteDialog['title'] = `確定刪除 ${user.name}`;
      this.storeUserDeleteDialog['message'] = '此動作無法還原，確定要進行？';

      this.storeUserDeleteShow = true;
    },

    storeUserDeleteClose() {
      this.storeUserDeleteShow = false;
    },

    async storeUserDeleteAction() {
      try {
        await stores.delAccessUser(this.storeId, this.storeUserDelete.memberUuid);

        this.storeUserDeleteShow = false;
        this.fetchStoreAccessList();
      } catch (err) {
        console.error(err);
        alert('無法刪除管理員權限');
      }
    },

    onKeywordChange() {
      this.storeUserList = this.storeUserListBackup.filter(item => item.name.toLowerCase().indexOf(this.keywords.toLowerCase()) > -1);
    }
  }
};
</script>